import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Paper from '@mui/material/Paper';
import Grid2 from '@mui/material/Grid2';
import Logo from 'assets/icons/logo/white.png';
import cartagena from 'assets/images/cities/cartagena.jpg';
import { Box } from '@mui/material';

const useStyles = makeStyles((theme) => ({
    experiencesHeader: {
        height: '400px',
        backgroundImage: `url(${cartagena})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
    },
    overlay: {
        position: 'absolute',
        background: '#000',
        height: '100%',
        width: '100%',
        opacity: '0.5'
    },
    city: {
        textAlign: 'center',
        lineHeight: '400px',
    },
    logoContainer: {
        position: 'absolute',
        left: 0,
        right: 0,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '17rem',
        top: '20vh',
        textAlign: 'center',
    },
    logo: {
        width: 'inherit',
        height: 'inherit',
    },
}));

export default function Header() {
    const classes = useStyles();

    return (
        <Box className={classes.experiencesHeader}>
            <Box className={classes.overlay}></Box>
            <Box className={classes.logoContainer}>
                <img src={Logo} alt="Logo" className={classes.logo} />
            </Box>
        </Box>
    );
}
